import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
} from "./Card";

export default function LineChartDailyRevenue({ data }) {
  const chartData = (data || []).map((item) => {
    const d = new Date(item.date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return {
      date: `${day}-${month}-${year}`,
      revenue: Number(item.revenue) || 0,
    };
  });

  const totalRevenue = chartData.reduce((sum, d) => sum + d.revenue, 0);
  const avgRevenue =
    chartData.length > 0 ? (totalRevenue / chartData.length).toFixed(0) : 0;

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const { date, revenue } = payload[0].payload;
    return (
      <div className="bg-white px-3 py-2 rounded-lg shadow-md border border-gray-200 text-xs text-black">
        <p className="font-semibold text-gray-700 mb-1">Jour {date}</p>
        <p className="text-green-600 font-bold">
          {revenue.toLocaleString()} DH
        </p>
      </div>
    );
  };

  return (
    <Card className="shadow-none border-none">
      <CardHeader>
        <CardTitle>Revenu par jour</CardTitle>
        <CardDescription className="text-xs">
          Revenu quotidien du mois
        </CardDescription>
      </CardHeader>

      <CardContent>
        <div className="h-80 w-full">
          {chartData.length === 0 ? (
            <div className="flex justify-center items-center h-full text-gray-400">
              Aucune donnée disponible
            </div>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart
                data={chartData}
                margin={{ top: 10, right: 20, bottom: 10, left: 0 }}
              >
                <defs>
                  <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="70%" stopColor="var(--color-primary-500)" stopOpacity={0.4} />
                    <stop offset="90%" stopColor="var(--color-primary-500)" stopOpacity={0} />
                  </linearGradient>
                </defs>
                
                <CartesianGrid stroke="#aaaaaa50" strokeDasharray="2 2" />
                <XAxis
                  dataKey="date"
                  tickLine={false}
                  axisLine={false}
                  tickMargin={10}
                  fontSize={12}
                />
                <YAxis
                  tickLine={false}
                  axisLine={false}
                  tickMargin={2}
                  allowDecimals={false}
                  fontSize={12}
                  tickFormatter={(value) => `${value.toLocaleString()} DH`}
                />
                <Tooltip content={<CustomTooltip />} />
                
                <Area
                  type="monotone"
                  dataKey="revenue"
                  stroke="var(--color-primary-500)"
                  strokeWidth={1}
                  fillOpacity={1}
                  fill="url(#colorRevenue)"
                  dot={{ r: 0, fill: "var(--color-primary-500)" }}
                  activeDot={{ r: 4, strokeWidth: 2, stroke: "#fff", fill: "var(--color-primary-500)" }}
                />
              </AreaChart>
            </ResponsiveContainer>
          )}
        </div>
      </CardContent>

      <CardFooter className="flex-col items-start gap-2 text-sm">
        <div className="flex gap-2 leading-none font-medium text-green-600 mt-1">
          Total revenu : {totalRevenue.toLocaleString()} DH
        </div>
        <div className="text-muted-foreground text-xs leading-none">
          Moyenne journalière : {avgRevenue.toLocaleString()} DH / jour
        </div>
      </CardFooter>
    </Card>
  );
}
